import { useQuery } from "@tanstack/react-query";
import { getAdminById } from "../Services/adminServices";

export const useAdminById = (id, { enabled = true, ...options } = {}) => {
  return useQuery({
    queryKey: ["admin", id],
    queryFn: () => getAdminById(id),
    enabled: Boolean(id) && enabled, // More explicit conversion
    staleTime: 5 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    ...options // Allow overriding any options
  });
};